import toast from 'react-hot-toast';
import { client } from '@/services/api/axios.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

export const useDeleteUserSessionMutation = (
  {
    onSuccess,
  }: {
    onSuccess?: (data: unknown) => void;
  } = { onSuccess: () => {} }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ sessionId }: { sessionId: string }) => {
      const deletePromise = client.delete(`/auth/sessions/${sessionId}`);

      const { data } = await toast.promise(deletePromise, {
        loading: 'Deleting session...',
        success: 'Session deleted successfully',
        error: (error) => {
          if (axios.isAxiosError(error)) {
            return error?.response?.data?.message || 'Failed to delete session';
          }
          return error instanceof Error ? error.message : 'Failed to delete session';
        },
      });

      return data.body;
    },
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['auth', 'sessions'],
      });
    },
  });
};
